<template>
  <div class="main-container rounded-t-3xl wrap auth h-full w-full">
    <locale-switcher-on-right></locale-switcher-on-right>
    <h3 class="display-2 text-align-center mb-3">{{ $t('onboard.title') }}</h3>
    <div class="my-8">
      <p class="text-align-center mb-6">{{ $t('onboard.p1') }}</p>
      <p class="text-align-center mb-6">{{$t('onboard.p2')}}</p>
      <p class="text-align-center strong">{{$t('onboard.p3')}}</p>
      <p class="text-align-center text-xs">{{$t('onboard.p4')}}</p>

    </div>
    <div class="flex justify-evenly items-start">
      <div class="text-align-center" v-if="Object.keys(this.kid).length !== 0 && this.kid.constructor === Object">
        <p class="text-align-center font-bold">{{$t('capsule.selectChild.child')}}</p>
        <router-link :to="{name: 'updateUser', params: {id:kid.id}}">
          <avatar
              type="child" size="large" :show-sticker="false"
              :img="kid.custom_image  ? kid.attachment_url: kid.avatar"/>
        </router-link>

        <p class="mt-1">{{ kid.firstname }}</p>

      </div>
      <div v-else>
        <router-link class="add-kid w-20 h-20"
                     :to="{name: 'SignInWelcome', params: {type: 'child',from:{page: 'SignInWelcomeHome'}}}">
          <p class="text-align-center font-bold">{{ $t('capsule.selectChild.child') }}</p>
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="40" cy="40" r="39.2593" fill="white" fill-opacity="0.3" stroke="#EEB706"
                    stroke-width="1.48148"
                    stroke-dasharray="3.7 3.7"/>
            <path
                d="M33.2255 43.1955C32.8166 43.1955 32.4611 43.0444 32.1588 42.7422C31.8566 42.4399 31.7055 42.0844 31.7055 41.6755V41.3022C31.7055 40.8933 31.8566 40.5377 32.1588 40.2355C32.4611 39.9333 32.8166 39.7822 33.2255 39.7822H37.5722C37.7322 39.7822 37.8122 39.7022 37.8122 39.5422V35.2755C37.8122 34.8666 37.9544 34.5111 38.2388 34.2088C38.5411 33.9066 38.8966 33.7555 39.3055 33.7555H39.9455C40.3544 33.7555 40.7011 33.9066 40.9855 34.2088C41.2877 34.5111 41.4388 34.8666 41.4388 35.2755V39.5422C41.4388 39.7022 41.5188 39.7822 41.6788 39.7822H46.0255C46.4344 39.7822 46.79 39.9333 47.0922 40.2355C47.3944 40.5377 47.5455 40.8933 47.5455 41.3022V41.6755C47.5455 42.0844 47.3944 42.4399 47.0922 42.7422C46.79 43.0444 46.4344 43.1955 46.0255 43.1955H41.6788C41.5188 43.1955 41.4388 43.2755 41.4388 43.4355V47.7022C41.4388 48.1111 41.2877 48.4666 40.9855 48.7688C40.7011 49.0711 40.3544 49.2222 39.9455 49.2222H39.3055C38.8966 49.2222 38.5411 49.0711 38.2388 48.7688C37.9544 48.4666 37.8122 48.1111 37.8122 47.7022V43.4355C37.8122 43.2755 37.7322 43.1955 37.5722 43.1955H33.2255Z"
                fill="#EEB706"/>
          </svg>
        </router-link>

      </div>
    </div>
    <primary-button :clicked="clicked" :disabled="familyState.users.length < 1" class="mt-12" @click.native="next">
      {{ $t('capsule.next') }}
    </primary-button>

  </div>
</template>

<script>
import Help from "@/components/Help";
import UniModal from "@/components/UniModal";
import Avatar from "@/components/Avatar";
import currentFamilyCheck from "@/library/currentFamilyCheck";
import {mapGetters} from "vuex";
import PrimaryButton from "@/components/PrimaryButton";
import LocaleSwitcherOnRight from "@/views/security/LocaleSwitcherOnRight";

export default {
  name: "SignInWelcomeHome",
  components: {LocaleSwitcherOnRight, PrimaryButton, Avatar, UniModal, Help},
  mixins: [currentFamilyCheck],
  computed: {
    ...mapGetters(['currentFamily']),
  },
  data() {
    return {
      openModal: false,
      kid: {},
      clicked: false
    };
  },
  methods: {
    /**
     * Check if there are users in currentFamily and add to parent and kik
     */
    checkUsers() {
      if (!this.familyState) {
        window.location.reload()
      }
      if (this.familyState.users.length > 0) {

        if (this.familyState.users.find(user => user.user_type === 'child')) {
          this.kid = this.familyState.users.find(user => user.user_type === 'child');

        }
      }
    },
    next() {
      this.clicked = true;
      if (this.familyState.users.length > 0) {
        this.$router.push({name: 'OnBoard'})
        this.clicked = false
      }
    }
  },
  updated() {
    this.checkUsers();
  },
  created() {
    this.checkUsers()
  }
}

</script>

<style scoped>

</style>